import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';

const { widthSmall } = breakpoints;

const UserGreeting = styled.span`
  label: UserGreeting;

  display: ${({ isGreetingLongerThan20Chars }) =>
    isGreetingLongerThan20Chars ? 'none' : 'inline'};

  @media (${widthSmall}) {
    display: ${({ isGreetingLongerThan42Chars }) =>
      isGreetingLongerThan42Chars ? 'none' : 'inline'};
  }
`;

const Styled = {
  UserGreeting,
};

export default Styled;
